import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faLocationArrow, faEnvelope } from '@fortawesome/free-solid-svg-icons';

import { useAllLocationsSelector } from '@stores/locations/selectors';
import { reqDealerAction } from '@stores/dealer/actions';
import { useDealerSelector } from '@stores/dealer/selectors';

import styles from './DealerHeader.module.scss';

export default function DealerHeader(pageProps) {
  const dispatch = useDispatch();

  const router = useRouter();
  const { locale } = router;

  const locations = useSelector(useAllLocationsSelector);
  const dealer = useSelector(useDealerSelector);

  const [dealerInfo, setDealerInfo] = useState({});

  const location = locations ? (locations.locations ? locations.locations[0] : null) : null;

  useEffect(() => {
    if (location) { // --- Use dealer code to get dealer info
      dispatch(reqDealerAction({ dealerCode: location?.code }));
    }
  }, [locations]);

  useEffect(() => {
    let info = {};
    if (dealer && Object.keys(dealer).length > 0) {
      info = {
        location: dealer,
        logoSrc: dealer.logo,
        locName: dealer.name,
        phone: dealer.phone,
        email: dealer.email,
        address: dealer.address1 + (dealer.address2 ? (' ' + dealer.address2) : '') + ', ' + dealer.city + ', ' + dealer.province + ' ' + dealer.postalCode,
      };
    }
    setDealerInfo(info);
  }, [dealer]);

  return (
    <>
      {dealerInfo && Object.keys(dealerInfo).length > 0 &&
        <div className={styles.dealerHeader}>
          <DealerInfoBox imgsrc={dealerInfo.logoSrc} />
          <DealerInfoBox title={locale=='fr'? 'Concessionnaire' : "Dealer"} text={dealerInfo.locName} />
          <DealerInfoBox title={locale=='fr'? 'Emplacement' : "Location"} text={dealerInfo.address} />
          <DealerInfoBox title={locale=='fr'? 'Téléphone' : 'Phone' } text={dealerInfo.phone} />
          <DealerInfoBox title={locale=='fr'? 'Adresse courriel' : 'Email' } text={dealerInfo.email} />
        </div>
      }
    </>
  );
}

function DealerInfoBox(props) {
  const boxTitle = props.title;
  const boxText = props.text;
  const imgSrc = props.imgsrc;

  if (imgSrc) {
    return (
      <div className={styles.dealerInfoBox + ' ' + styles.withLogo}>
        <div className={styles.logo}>
          <img src={imgSrc} />
        </div>
      </div>
    );
  }

  let faIcon = '';
  if (boxTitle == 'Dealer') {
    faIcon = <span className={styles.iconLetter}>K</span>;
  } else if (boxTitle == 'Location') {
    faIcon = <FontAwesomeIcon icon={faLocationArrow} flip="horizontal" />;
  } else if (boxTitle == 'Email') {
    faIcon = <FontAwesomeIcon icon={faEnvelope} flip="horizontal" />;
  } else {
    faIcon = <FontAwesomeIcon icon={faPhone} flip="horizontal" />;
  }

  return (
    <div className={styles.dealerInfoBox}>
      <div className={styles.boxTitle}>
        <div className={styles.icon}>{faIcon}</div>
        <div className={styles.title}>{boxTitle}</div>
      </div>
      <div className={styles.text}>{boxText}</div>
    </div>
  );
}
